import { Dispatch, ReactNode, SetStateAction } from 'react';
import { ITransportType } from '../../../../reducer/user';
import { vehicleKeys } from './consts';

export type Props = {};

export type Context = {
  vehicle: Vehicle | null;
  toggleDetailsOpen: () => void;
  selectedCam: number;
  onSelectCam: (cam: number) => void;
  requestId: string | null;
};

export type Vehicle = {
  agency: string;
  branch: string;
  cameraCount: number;
  cameraNames: string[];
  cards: number;
  center: string;
  column: null | string;
  depotNumber: number;
  driverFirstName: null | string;
  driverLastName: null | string;
  driverMiddleName: null | string;
  gosNomer: string;
  id: number;
  isOnline: boolean;
  is_video_uploading: boolean;
  model: string;
  pass_in: number;
  pass_out: number;
  route: null | string;
  routeType: string;
  route_id: null | number;
};

export type TabProps = {
  active?: boolean;
  icon?: string;
  onSelect: () => void;
};

export enum ViewMode {
  grid,
  single,
}

export type VehicleDetailsPanelRenderFn = (
  key: keyof typeof vehicleKeys,
  conf: {
    transporttypes: ITransportType[];
    vehicle: Vehicle;
  }
) => ReactNode;
